import { createCalendarViewTypes } from "dora-contracts";
import * as t from "io-ts";

export const { calendarViewDataT } = createCalendarViewTypes({
  dateTime: t.string,
  date: t.string,
});

export type CalendarViewData = t.TypeOf<typeof calendarViewDataT>;
export type CalendarViewTrailerSectionData = t.TypeOf<typeof calendarViewDataT>[0];
export type CalendarViewRouteData = t.TypeOf<typeof calendarViewDataT>[0]["routes"][0];
export type CalendarViewRouteCargoData = t.TypeOf<typeof calendarViewDataT>[0]["routes"][0]["cargos"][0];
export type CalendarViewRouteStopData = t.TypeOf<typeof calendarViewDataT>[0]["routes"][0]["cargos"][0]["stops"][0];

export type CalendarViewFilterType = "routes";